<template>
    <div class="flex">
        <vs-button
            class="ml-1" size="small" @click="modalNewPayment()" :disabled="projectResolution !== null" color="#303f9f">Generar ficha</vs-button>
        <!-- <vs-button style="margin-top: 5px" class="ml-2" size="small" color="#303f9f" @click="getSlips">Ver fichas</vs-button> -->
        <vs-button color="#303f9f" size="small" class="ml-2" @click="downloadUniqueSlip">Ficha única</vs-button>


        <!--Componente para ejecución de pago inicial offline-->
        <project-initial-payment-offline
            class="ml-4"
            :project_id="project_id"
            :amount="initialPaymentAmount"
        />

        <vs-popup :active.sync="showDialog" title="Generar ficha de pago">
          <h6>La ficha de pago tiene una vigencia de 30 días.</h6>
          <div class="mt-6">
              <vs-button class="mr-2" color="dark" @click="showDialog = false">Cerrar</vs-button>
              <vs-button @click="generateNewCardPayment()">Generar</vs-button>
          </div>
        </vs-popup>

        <!-- MODAL FICHAS -->
        <vs-popup title="Fichas creadas vigentes" :active.sync="popupActivo">
          <vs-table
              ref="slipsTable"
              stripe
              :data="references"
              noDataText="No hay datos disponibles"
          >
              <template slot="thead">
              <vs-th>Monto</vs-th>
              <vs-th>Fecha de expiración</vs-th>
              <vs-th></vs-th>
              </template>

              <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                  <vs-td>{{moneyFormat(tr.amount, 2)}}</vs-td>
                  <vs-td>{{tr.expiration_date}}</vs-td>
                  <vs-td>
                    <a :href="$sanitizeUrl(tr.public_url)" target="_blank" rel="noopener">
                      <em class="material-icons">open_in_new</em>
                    </a>
                  </vs-td>
              </vs-tr>
              </template>
          </vs-table>
        </vs-popup>
        <!--  -->
    </div>
</template>

<script>
    import NewCardPaymentModal from '../../views/admin/projects/process-flow/new-cardpayment-modal';
    import ProjectInitialPaymentOffline from "./ProjectInitialPaymentOffline";
    import {mapState} from "vuex";
    import formatHelper from '@mixins/formatHelper';

    export default {
        name: "PaymentCardOptionsButton",
        mixins: [formatHelper],
        props: ['projectResolution', 'initialPaymentUrl', 'project_id', 'initialPaymentAmount'],
        components: {
            'new-cardpayment-modal': NewCardPaymentModal,
            'project-initial-payment-offline': ProjectInitialPaymentOffline
        },
        data: () => ({
            dueDate: '',
            showDialog: false,
            popupActivo:false,
            references: []
        }),
        computed: {
            ...mapState('auth', ['user']),
        },
        methods: {
            openCardPayment() {
                window.open(this.initialPaymentUrl + '/?access_token=' + this.user.access_token);
            },
            modalNewPayment() {
                this.showDialog = true;
            },
            async getSlips(){
                this.showLoading(true);
                await axios.get('/api/cobranza/adeudos/' + this.project_id).then(response => {
                    this.references = response.data.references;
                    this.popupActivo = true;
                    this.showLoading(false);
                }).catch(error => {
                    this.showLoading(false);
                    swal("Error", "Hubo un error al obtener las fichas", "error")
                });
            },
            async downloadUniqueSlip() {
                this.showLoading(true);
                await axios.get('/api/cobranza/adeudos/' + this.project_id).then(response => {
                    this.showLoading(false);
                    if (response.data.unique_slip) {
                        window.open(`${response.data.unique_slip.public_url}`, "_blank");
                    }
                    else{
                        swal("Error", "Este solicitante no cuenta con una ficha de pago única", "error")
                    }
                }).catch(error => {
                    this.showLoading(false);
                    swal("Error", "Hubo un error al obtener las fichas", "error")
                });
            },
            async generateNewCardPayment() {
                try {
                    let res = await axios.post(`/api/project/${this.project_id}/new_card_payment`, {
                        "due_date": this.dueDate
                    });

                    this.$emit("update:initialPaymentUrl", res.data.initial_payment_url)
                    this.showDialog = false;
                    swal("Ok!", "Se ha generado una nueva ficha", "success");
                } catch (ex) {
                    console.error(ex)
                    swal("Upss!", "Hubo un error al generar la ficha de pago", "error")
                }
            },
        }
    }
</script>

<style scoped>

</style>
